import type { ComponentProps } from 'react'
import { cn } from '#src/cn.ts'

export function TypographyOverline({
  className,
  ...props
}: ComponentProps<'p'>) {
  return (
    <p
      className={cn(
        'font-bold text-foreground-tertiary text-xs uppercase tracking-wider',
        className
      )}
      {...props}
    />
  )
}
